export default __webpack_public_path__ + "static/media/gallery-wip-emitter_07.747e2b31.jpg";